export default "./images/survio-1KdTn-assets-surveyManagement.svg";